/** TextureButton registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTextureButton } from './parser';
const textureButtonRegistration = {
    typeName: 'TextureButton',
    parser: parseTextureButton,
};
nodeRegistry.register(textureButtonRegistration);
//# sourceMappingURL=index.js.map